// libraries.
import { Col, Row } from 'react-bootstrap';
import { Layout } from '@shared';

// components.
import { ReassignTaskTable } from './components/ReassignTaskTable';
import { SidebarDocuments } from '../DocumentsAuditDashboard/components/SideBarDocuments/SideBarDocuments';
import { DocumentsActionsBar } from '../DocumentsAuditDashboard/components/DocumentsActionsBar/DocumentsActionsBar';

export const ReassignDocumentsTable = () => {
  return (
    <Layout>
      <SidebarDocuments />
      <div className="h-100 w-100">
        <DocumentsActionsBar />
        <Row
          className="m-0"
          style={{ height: 'calc(100% - 96px)', width: '100%' }}
        >
          <Col className="p-4 h-100">
            <ReassignTaskTable />
          </Col>
        </Row>
      </div>
    </Layout>
  );
};
